import styled from "styled-components";
import { COLORS } from "../../../../../assets/constants/styles";
import {
  SummarySection,
  SectionHeading,
  SectionBox,
} from "../InfoSection/InfoSection.styles";

export { SummarySection, SectionHeading, SectionBox };

export const SourcesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const SourceItem = styled.div`
  padding: 0.75rem;
  border-radius: 0.5rem;
  background-color: ${COLORS.lightestViolet};
`;

export const SourceTitle = styled.div`
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: ${COLORS.grey};
  font-size: 0.875rem;
`;

export const SourceUrl = styled.a`
  font-size: 0.75rem;
  color: ${COLORS.violet};
  text-decoration: none;
  word-break: break-all;
  transition: all 0.2s ease;

  &:hover {
    text-decoration: underline;
  }
`;
